export default "__VITE_ASSET__B_Jdpu0M__"